import axios from 'axios'
import * as base from '@/api/endpoint/base'
import * as auth from '@/api/endpoint/auth'

export const loginRequest = (json: any) => {
    const resp = axios({
        method: 'post',
        url: `${base.BaseAuth()}${auth.Signin()}`,
        data: json
    }).then((response) => {
        return response.data
    })
    return resp
}

export const signupRequest = (json: any) => {
    const resp = axios({
        method: 'post',
        url: `${base.BaseAuth()}${auth.Signup()}`,
        data: json
    }).then((response) => {
        return response.data
    })
    return resp
}
export const checkRequest = () => {
    const token = base.token()
    const resp = axios({
        method: 'get',
        headers: {
            'Authorization': `Bearer ${base.token()}`
        },
        url: `${base.BaseProvider()}${auth.ProviderCheck()}`,
    }).then((response) => {
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(response.data.data));
        return response.data
    })
    return resp
}





